export var ColumnTypes;

(function (ColumnTypes) {
  ColumnTypes["Text"] = "Text";
  ColumnTypes["Number"] = "Number";
  ColumnTypes["Date"] = "Date";
  ColumnTypes["Year"] = "Year";
  ColumnTypes["Period"] = "Period";
  ColumnTypes["Currency"] = "Currency";
  ColumnTypes["Percent"] = "Percent";
})(ColumnTypes || (ColumnTypes = {}));